module.exports = __webpack_public_path__ + "static/media/accounting.c24ac9fa.gif";